export const FAQS = [
  {
    answer:
      'Share your referral link with potential customers who have a home to sell. ' +
      'When they use your link to request an Opendoor offer on your home, that customer will ' +
      'be attributed to you and appear in your dashboard. You can then use your dashboard to ' +
      'stay up-to-date on your customers’ progress and help support their home trade-in journey.',
    question: 'How does my Opendoor referral link work?',
  },
  {
    answer: (
      <span>
        Opendoor respects the agreements between agents and their customers. If a customer has a
        listing agreement in place, Opendoor will work directly with the agent to facilitate the
        home sale. If there is no listing agreement in place, agents can earn a 1% referral fee if
        they refer the seller to Opendoor before the home is listed{' '}
        <a
          href="https://www.opendoor.com/w/agents#faq-referral"
          target="_blank"
          rel="noopener noreferrer"
        >
          (restrictions apply)
        </a>
        .{' '}
        <i>
          <b>Either way, agents are still able to collect commission from the builder.</b>
        </i>
      </span>
    ),
    question: 'How does Opendoor work with Realtors?',
  },
  {
    answer: (
      <span>
        When your customers sells their home to Opendoor, they pay a service charge similar to the
        agent commission in a traditional sale, but they get the convenience of no showings and
        complete control over their moving timeline. You can use this{' '}
        <a
          href="https://www.opendoor.com/w/builder-calculator"
          target="_blank"
          rel="noopener noreferrer"
        >
          comparison calculator
        </a>{' '}
        to help customers to estimate the net proceeds of selling a home to Opendoor vs. the
        traditional way.
      </span>
    ),
    question: 'How does the cost of selling to Opendoor compare with a traditional sale?',
  },
  {
    answer:
      'The fastest way to see if Opendoor can make an offer on a customer’s home is to use ' +
      'your referral link to launch the Opendoor seller flow and enter the customer’s address. ' +
      'Opendoor will then tell you whether or not we can make an offer on the home.',
    question: 'What areas does Opendoor buy in?',
  },
  {
    answer: (
      <span>
        Here’s a{' '}
        <a
          href="https://www.opendoor.com/w/faq/what-types-of-homes-does-opendoor-purchase"
          target="_blank"
          rel="noopener noreferrer"
        >
          quick guide
        </a>{' '}
        on the types of homes that Opendoor buys.
      </span>
    ),
    question: 'What types of homes does Opendoor buy?',
  },
  {
    answer:
      'Opendoor does not represent any parties in your contract or take any of your commission. ' +
      'Our goal is to provide new home sales associates with a frictionless solution to eliminate contingencies, ' +
      'and new homebuyers with a convenient and certain path to sell their home. There is no fee for homebuilders ' +
      'to partner with Opendoor.',
    question: 'Is Opendoor part of my new home contract?',
  },
];
